import * as React from 'react';
import { AppBar, Logout, UserMenu } from 'react-admin';
import { Link } from 'react-router-dom';
import {
    MenuItem,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';

const ConfigurationMenu = React.forwardRef((props, ref) => {
    return (
        <MenuItem
            component={Link}
            ref={ref}
            {...props}
            to="/changepassword"
        >
            <SettingsIcon />
            &nbsp;&nbsp;Change Password
        </MenuItem>
    );
});

const CustomUserMenu = () => (
    <UserMenu>
        <ConfigurationMenu />
        <Logout />
    </UserMenu>
);

const MyAppBar = props => <AppBar {...props} userMenu={<CustomUserMenu />} style={{ backgroundColor: "#EB3B67" }} />;

export default MyAppBar;
